// Shared by React and the build's static-code hint. This selects an entry only;
// neither these query parameters nor initDataUnsafe authorize any API access.
export function storeEntry(location, telegramStartParam) {
  const params = new URLSearchParams(location.search);
  const startParam = String(telegramStartParam || params.get('tgWebAppStartParam') || '');
  if (location.pathname === '/commerce-e2e' || params.get('commerceE2E') === '5' || startParam === 'commerce_e2e_5') return { botId:5 };
  const deep = startParam.match(/^store_(\d+)(?:_(\d+))?$/);
  const botId = Number(params.get('store') || deep?.[1]);
  const productId = Number(params.get('product') || deep?.[2] || 0);
  const quoteId = String(params.get('quote') || '').trim();
  return Number.isSafeInteger(botId) && botId > 0 ? { botId, productId:Number.isSafeInteger(productId) && productId > 0 ? productId : 0, quoteId } : null;
}
